import { DashboardScope } from '@api/domain/types';
import { DashboardDrilldownScope } from '@v2/pages/dashboard/common/types/drilldown';

import { DashboardDrilldownBreadcrumbKey } from '@v2/pages/dashboard/modules/drilldown/components/DashboardDrilldownWrapper/components/DashboardDrilldownBreadcrumb/types';

export const BREADCRUMB_SEPARATOR = '›';

export const BREADCRUMB_ITEM_HORIZONTAL_SPACING = 4;
export const BREADCRUMB_ITEM_VERTICAL_PADDING = 2;

export const BREADCRUMB_KEY_ORDER: DashboardDrilldownBreadcrumbKey[] = [
  DashboardDrilldownBreadcrumbKey.DateRange,
  DashboardDrilldownBreadcrumbKey.ParentScope,
  DashboardDrilldownBreadcrumbKey.Entity,
];

export const DRILLDOWN_PARENT_SCOPE_PLURAL: Record<DashboardDrilldownScope, string> = {
  [DashboardDrilldownScope.Machine]: 'Machines',
  [DashboardDrilldownScope.Customer]: 'Customers',
  [DashboardDrilldownScope.Part]: 'Parts',
  [DashboardDrilldownScope.NcFile]: 'NC Files',
};

export const DRILLDOWN_SCOPE_TO_DASHBOARD_SCOPE: Record<DashboardDrilldownScope, DashboardScope> = {
  [DashboardDrilldownScope.Machine]: DashboardScope.Machine,
  [DashboardDrilldownScope.Customer]: DashboardScope.Customer,
  [DashboardDrilldownScope.Part]: DashboardScope.Part,
  [DashboardDrilldownScope.NcFile]: DashboardScope.NcFile,
};
